import React from 'react';
import PropTypes from 'prop-types';
import { Drawer, Stack, Button } from '@mantine/core';
import { TYPE_TO_READABLE_STRING_MAP } from 'constants/menuManagement';

import { useMediaQuery } from '@mantine/hooks';

import { breakpoints } from 'styles/theme.variables';

function AddTypeChoiceDrawer({
  itemType,
  opened,
  close,
  openAddNewDrawer,
  openAddItemFromPosDrawer,
}) {
  const readableItemType = TYPE_TO_READABLE_STRING_MAP[itemType];
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.maxMobile})`);

  return (
    <Drawer
      opened={opened}
      onClose={close}
      title={`Add ${readableItemType}`}
      size={isMobile ? 'sm' : 'lg'}
    >
      <Stack gap="xs">
        <Button
          fullWidth
          onClick={() => {
            openAddNewDrawer();
            close();
          }}
        >
          {`Add new ${readableItemType}`}
        </Button>
        <Button
          fullWidth
          onClick={() => {
            openAddItemFromPosDrawer();
            close();
          }}
        >
          Add from your POS
        </Button>
      </Stack>
    </Drawer>
  );
}

AddTypeChoiceDrawer.propTypes = {
  itemType: PropTypes.string.isRequired,
  opened: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  openAddNewDrawer: PropTypes.func.isRequired,
  openAddItemFromPosDrawer: PropTypes.func.isRequired,
};

export default AddTypeChoiceDrawer;
